import { useTranslation } from "react-i18next";
import { Box, Button, ButtonGroup } from "@mui/material";

interface OcFormEditorAddressSelectorProps {
  addressType: string;
  isNewAddress: boolean;
  data: Record<string, { city?: string }>;
  onShowFormEditor: (type: string) => void;
  isMobile: boolean;
}

export const OcFormEditorAddressSelector = ({
  addressType,
  isNewAddress,
  data,
  onShowFormEditor,
  isMobile,
}: OcFormEditorAddressSelectorProps) => {
  const { t } = useTranslation();

  if (!isNewAddress) return null;

  const types = ["permanentAddress", "temporaryAddress", "serviceAddress"];

  const handleClick = (type: string) => {
    onShowFormEditor(type);
  };

  return (
    <Box
      id="button-group"
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      paddingTop="36px"
    >
      <ButtonGroup
        orientation={isMobile ? "vertical" : "horizontal"}
        fullWidth={isMobile ? true : false}
      >
        {types.map((item, index) => {
          const isSelectedType = item === addressType;
          const isExist = data[item].city ? true : false;
          const replacedType = item?.replaceAll(/([a-z])([A-Z])/g, "$1_$2").toUpperCase();

          return (
            <Button
              key={`${item}-button-${index}`}
              variant={isSelectedType ? "contained" : "outlined"}
              color={isSelectedType ? "primary" : "inherit"}
              disabled={isExist}
              disableElevation
              onClick={() => handleClick(item)}
              sx={{
                color: isSelectedType ? "primary" : "",
              }}
            >
              {t(`MY_HR_${replacedType}`)}
            </Button>
          );
        })}
      </ButtonGroup>
    </Box>
  );
};

export default OcFormEditorAddressSelector;
